import { formatPrice, getPrice } from 'utilities/content/content-utilities';
import { DeliveryAndReturnContentItem } from 'types/Product';

const getFfmHtml = (
  site: string | undefined,
  deliveryPrices: { type: string; value: number }[],
  brand: string,
): DeliveryAndReturnContentItem => {
  const fallbackPricesVery: Record<string, number> = {
    STD: 8.99,
  };

  const fallbackkPriceLittlewoods: Record<string, number> = {
    STD: 0.0,
  };

  const content: DeliveryAndReturnContentItem = {
    pageText: '',
    pageLink: '',
    modalHeading: '',
    modalBody: '',
  };

  if (site === 'very') {
    content.pageText = `Delivered by <strong>${brand}</strong>`;
    content.pageLink = 'Find out more about delivery and returns';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <p>This item will be delivered directly from the supplier, therefore the delivery and returns policy may be unique to them.</p>
      <h3 class="delivery-return-info"><strong>Delivery &amp; returns information</strong></h3>
      <dl>
        <dt><strong>Delivery (${formatPrice(site, getPrice('STD', fallbackPricesVery, deliveryPrices))})</strong></dt>
        <dd>Within 5 working days</dd>
        <dt><strong>Returns (FREE)</strong></dt>
        <dd>Standard Policy - Within 28 days of receipt</dd>
      </dl>
      <p>Please note, delivery to a BFPO address is unavailable from some of our suppliers.</p>
      <p class="bottom-text-model">Very.co.uk requires our suppliers to use the minimum standards required to meet our own delivery &amp; returns policies.</p>
    `;

    return content;
  }
  if (site === 'littlewoods') {
    content.pageText = `Delivered by <strong>${brand}</strong>`;
    content.pageLink = 'Find out more about delivery and returns';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <p>This item will be delivered directly from the supplier, therefore the delivery and returns policy may be unique to them.</p>
      <h3 class="delivery-return-info"><strong>Delivery &amp; returns information</strong></h3>
      <dl>
        <dt><strong>Delivery (${formatPrice(site, getPrice('STD', fallbackkPriceLittlewoods, deliveryPrices))})</strong></dt>
        <dd>Within 5 working days</dd>
        <dt><strong>Returns (FREE)</strong></dt>
        <dd>Standard Policy - Within 28 days of receipt</dd>
      </dl>
      <p>Please note, delivery to a BFPO address is unavailable from some of our suppliers.</p>
      <p class="bottom-text-model">Littlewoods requires our suppliers to use the minimum standards required to meet our own delivery &amp; returns policies.</p>
    `;

    return content;
  }
  return content;
};

export default getFfmHtml;
